import {
  Root,
  Item,
  ToggleGroupSingleProps,
} from '@radix-ui/react-toggle-group';
import { clsx } from 'clsx';
import { ComponentPropsWithRef, createContext, useContext } from 'react';
import {
  SegmentedControlSize,
  SegmentedControlVariant,
  segmentedControl,
  segmentedControlItem,
  segmentedControlItemSizes,
  segmentedControlSizes,
  segmentedControlVariants,
} from './segmented-control.css.ts';

export type { SegmentedControlVariant, SegmentedControlSize };

const SegmentedControlSizeContext = createContext<SegmentedControlSize>('md');

export type SegmentedControlProps = Omit<
  ComponentPropsWithRef<typeof Root> & ToggleGroupSingleProps,
  'type'
> & {
  variant?: SegmentedControlVariant;
  size?: SegmentedControlSize;
};

export const SegmentedControl = ({
  ref,
  className,
  children,
  onValueChange,
  variant = 'primary',
  size = 'md',
  ...props
}: SegmentedControlProps) => (
  <SegmentedControlSizeContext.Provider value={size}>
    <Root
      ref={ref}
      className={clsx(
        segmentedControl,
        segmentedControlVariants[variant],
        segmentedControlSizes[size],
        className,
      )}
      onValueChange={(value) => {
        if (!value) return;
        onValueChange?.(value);
      }}
      type={'single'}
      {...props}
    >
      {children}
    </Root>
  </SegmentedControlSizeContext.Provider>
);

export const SegmentedControlItem = ({
  ref,
  className,
  children,
  ...props
}: ComponentPropsWithRef<typeof Item>) => {
  const size = useContext(SegmentedControlSizeContext);
  return (
    <Item
      ref={ref}
      className={clsx(
        segmentedControlItem,
        segmentedControlItemSizes[size],
        className,
      )}
      {...props}
    >
      {children}
    </Item>
  );
};
